import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { PreferenceSetEntity } from './preference-set.entity';
import { PreferenceEntity } from './preference.entity';

@Index('_fk__preference__id', ['fkPreferenceId'], {})
@Index('_fk__preference_set__id_default', ['fkPreferenceSetIdDefault'], {})
@Index(
	'unique_workd_user_preference',
	['workdUserId', 'fkPreferenceId', 'fkObjectIdReference', 'referenceId'],
	{ unique: true },
)
@Entity('_preference_user')
export class PreferenceUserEntity extends BaseEntity {
	@Column('int', { name: '_workd__user__id', nullable: true, unsigned: true })
	public workdUserId!: number | null;

	@Column('int', {
		name: '_fk__preference__id',
		nullable: true,
		unsigned: true,
	})
	public fkPreferenceId!: number | null;

	@Column('int', {
		name: '_fk__preference_set__id_default',
		nullable: true,
		unsigned: true,
	})
	public fkPreferenceSetIdDefault!: number | null;

	@Column('int', {
		name: '_fk__object__id_reference',
		unsigned: true,
		default: () => "'0'",
	})
	public fkObjectIdReference!: number;

	@Column('int', { name: '_referenceId', unsigned: true, default: () => "'0'" })
	public referenceId!: number;

	@ManyToOne(
		() => PreferenceEntity,
		(preference) => preference.preferenceUsers,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk__preference__id', referencedColumnName: 'id' }])
	public fkPreference!: PreferenceEntity;

	@ManyToOne(
		() => PreferenceSetEntity,
		(preferenceSet) => preferenceSet.preferenceUsers,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk__preference_set__id_default', referencedColumnName: 'id' },
	])
	public fkPreferenceSetIdDefault2!: PreferenceSetEntity;
}
